import React from 'react';
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { CompletedStepCheckmark } from 'ui-components/components/completed-step-checkmark/completed-step-checkmark';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import styles from './fbs-application-drawer-section.module.less';
import { messages } from './messages';

export const FbsApplicationDrawerSection = ({
  children,
  headerMessageDescriptor,
  isComplete,
  isEditing,
  isDisabled,
  isContinueDisabled,
  onContinue,
  onEdit,
}) => {
  const shouldShowEditButton = onEdit && !isDisabled && isComplete && !isEditing;
  const shouldShowContinueButton = onContinue && !isDisabled && (!isComplete || isEditing);

  return (
    <div className={classnames(styles['fbs-application-drawer-section'], { [styles['is-disabled']]: isDisabled })}>
      <div className={styles['section-header']}>
        <CompletedStepCheckmark isComplete={isComplete ? !isEditing : null} />
        <Text className={styles['section-title']} textType={TextType.H3} value={headerMessageDescriptor} />
        {shouldShowEditButton ? (
          <Button className={styles['edit-button']} onClick={onEdit} theme={THEME_CONSTANTS.ghost}>
            <FontAwesomeIcon className={styles['edit-button-icon']} icon={faPen} />
            <FormattedMessage {...messages.edit} />
          </Button>
        ) : null}
        {shouldShowContinueButton ? (
          <Button disabled={isContinueDisabled} onClick={onContinue} theme={THEME_CONSTANTS.primary}>
            <FormattedMessage {...messages.continue} />
          </Button>
        ) : null}
      </div>
      {!isDisabled && <div className={styles['section-content']}>{children}</div>}
    </div>
  );
};
